module.exports = __webpack_public_path__ + "img/chain_industry-solution6.05d40d86.png";